export default __webpack_public_path__ + "static/media/homepage-light-theme-img.a61acedb.png";